import { Calendar, message, Table } from "antd";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import CreateSlots from "./components/CreateSlots";
import { GoLocation } from "react-icons/go";
import type { Dayjs } from "dayjs";
import type { CalendarProps } from "antd";
import moment from "moment";
import { RiDeleteBinLine } from "react-icons/ri";
import "moment/locale/en-gb";
import { handleCreateSlots, handleFetchAllSlots } from "../../../apis/slots";
import Something from "../../../components/Something";
import BackLink from "../../../components/BackLink";
import { FiEdit } from "react-icons/fi";

moment.locale("en-gb");
export default function Slots() {
  const [createModal, setCreateModal] = useState<boolean>(false);
  const today = moment(new Date()).format("YYYYMMDD");
  const [date, setDate] = useState<any>(today);
  const queryClient = useQueryClient();

  const {
    data: slots,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["slots", date],
    queryFn: () => handleFetchAllSlots({ date }),
  });

  const onPanelChange = (value: Dayjs, mode: CalendarProps<Dayjs>["mode"]) => {
    console.log(value.format("YYYY-MM-DD"), mode);
  };

  const onDateChange = (value: any) => {
    setDate(value.format("YYYYMMDD"));
  };

  const { mutate } = useMutation({
    mutationFn: handleCreateSlots,
    onSuccess: () => {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["attendances"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const handleAssignAttendance = async ({ isPresent, record }: any) => {
    await mutate({
      data: { isPresent, isFilled: true },
      _id: slots?.data?._id,
      technicianId: record?._id,
    });
  };

  const columns = [
    {
      title: "S/N",
      width: 20,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "DATE",
      width: 70,
      render: (record: any) => (
        <div className="">{moment(record?.startTime).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      title: "START TIME",
      width: 150,
      render: (record: any) => (
        <div className="">{moment(record?.startTime).format("hh:mm A")}</div>
      ),
    },
    {
      title: "END TIME",
      width: 150,
      render: (record: any) => (
        <div className="">{moment(record?.endTime).format("hh:mm A")}</div>
      ),
    },
    {
      title: "CAPACITY",
      width: 50,
      render: (record: any) => (
        <div className="flex items-center">{record?.limit}</div>
      ),
    },
    {
      title: "BOOKED",
      width: 50,
      render: (record: any) => (
        <div className="flex items-center">{record?.entered}</div>
      ),
    },
    {
      title: "AVAILABLE",
      width: 50,
      render: (record: any) => (
        <div className="flex items-center">
          {record?.limit - record?.entered}
        </div>
      ),
    },
    {
      title: "ACTION",
      width: 50,
      render: (record: any) => (
        <div className="flex items-center">
          <button
            onClick={() => {
              handleAssignAttendance({
                isPresent: true,
                record,
              });
            }}
            className="flex justify-center items-center mx-1 text-gray-700  rounded-sm px-2 py-1  cursor-pointer"
          >
            <FiEdit color="#ca8a04" />
          </button>
          <button
            onClick={() => {
              handleAssignAttendance({
                isPresent: false,
                record,
              });
            }}
            className="flex justify-center items-center text-gray-700  rounded-sm px-2 py-1 cursor-pointer"
          >
            <RiDeleteBinLine color="#dc2626" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-gray-100">
      <BackLink />
      <div className="bg-white m-1">
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="grid grid-cols-12 gap-x-4">
            <div className="col-span-12 sm:col-span-2 border-r min-h-screen p-2">
              <Calendar
                fullscreen={false}
                onPanelChange={onPanelChange}
                onChange={onDateChange}
              />
            </div>

            <div className="col-span-12 sm:col-span-10">
              <div className="border-b mb-2">
                <div className="flex justify-between items-center">
                  <div className="flex flex-col py-2">
                    <div className="text-xl font-bold">BOOKING SLOTS  </div>
                    <div className="text-xs uppercase text-green-600 font-bold">
                        {moment(date).format("Do MMM YYYY")} 
                    </div>
                  </div>
                  <div className="">
                    <button
                      onClick={() => setCreateModal(true)}
                      className="flex mx-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                    >
                      + New
                    </button>
                  </div>
                </div>
              </div>
              {slots?.records?.length > 0 ? (
                <div className="">
                  {slots?.records?.map((site: any, index: number) => (
                    <div key={index} className="mb-4">
                      <div className="uppercase mb-2 flex items-center">
                        <GoLocation />
                        <span className="mx-2">{site?._id}</span>
                      </div>
                      <Table
                        columns={columns}
                        dataSource={site?.slots[0]?.units || []}
                        size="small"
                        bordered
                        pagination={false}
                        loading={isLoading}
                        rowKey="id"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="">
                  <div className="text-center my-8">No Slots Created</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <CreateSlots isVisible={createModal} setVisible={setCreateModal} />
    </div>
  );
}
